export const LoyaltyDashboard = {
    "loyaltyDashboard.benefits": "benefits",
    "loyaltyDashboard.birthday": "birthday",
    "loyaltyDashboard.earnPoints": "earnPoints",
    "loyaltyDashboard.loyaltyConfig": "loyaltyConfig",
    "loyaltyDashboard.loyaltySubmitAReceipt" : "loyaltySubmitAReceipt",
    "loyaltyDashboard.pointsHistory": "pointsHistory",
    "loyaltyDashboard.rewards": "rewards"
};
